import { fetchUsers } from '$lib/userAPI';
import { writable } from 'svelte/store';

const notifications = writable([]);

export { notifications };
